module.exports = "https://dashboard.cdn.gifty.nl/6189/images/blueprint-bg.svg?8d3485b350f4f35dc835dd490110a63a";